export const CasesBase = () => {};
